var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOntarioIconChevronDown = function SvgOntarioIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.4 8.6 4.6 4.58 4.6-4.58L18 10l-6 6-6-6z"
  })));
};
export { SvgOntarioIconChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTcuNCA4LjZsNC42IDQuNTggNC42LTQuNThMMTggMTBsLTYgNi02LTYgMS40LTEuNHoiIGZpbGw9IiMwMDAiLz48L3N2Zz4=";